"use strict";

var _ = require('lodash');
module.exports = /*@ngInject*/function ($document, $window) {
  return {
    template: '<div class="sidebar" ng-transclude></div>',
    replace: true,
    transclude: true,
    restrict: 'E',
    // eslint-disable-next-line object-shorthand
    link: function link(scope) {
      var sideWidth = 240;
      var containerWidth = 1170;
      var contentWidth = containerWidth + 2 * sideWidth; //middle container + 2 times the sidenav width
      // eslint-disable-next-line no-param-reassign
      scope.sideMenu = $window.innerWidth > contentWidth ? scope.navi.defaultMenuOpen : false; //default open or close for sidemenu

      $window.addEventListener('resize', _.debounce(function () {
        scope.$apply(function () {
          if ($window.innerWidth <= contentWidth) {
            // eslint-disable-next-line no-param-reassign
            scope.sideMenu = false;
          } else {
            // eslint-disable-next-line no-param-reassign
            scope.sideMenu = scope.navi.defaultMenuOpen || scope.sideMenu;
          }
        });
      }, 100), true);
      $document.bind('click', function (event) {
        var isMenuClicked = event.target.classList.contains('hamburger');
        if (isMenuClicked) {
          // eslint-disable-next-line no-param-reassign
          scope.sideMenu = !scope.sideMenu;
        } else if ($window.innerWidth <= contentWidth || !scope.navi.defaultMenuOpen) {
          // eslint-disable-next-line no-param-reassign
          scope.sideMenu = false;
        }
        scope.$apply();
      });
    }
  };
};